import { useStore } from 'effector-react'
import * as React from 'react'
import { useParams } from 'react-router-dom'

import {
  $clientProfile,
  $errorManualTransfer,
  $fullPartnerForClient,
  $manualTransfer,
  $partner,
  $partnerError,
  clientProfileMounted,
  partnerMounted,
  updateAutoWithdrawalStatus,
} from './model'

export const useClientProfile = () => {
  const { clientID } = useParams()
  const clientProfile = useStore($clientProfile)
  const manualTransfer = useStore($manualTransfer)
  const manualTransferError = useStore($errorManualTransfer)
  const partner = useStore($partner)
  const partnerError = useStore($partnerError)
  const fullPartnerForClient = useStore($fullPartnerForClient)
  const loadingAutoWDStatus = useStore(updateAutoWithdrawalStatus.pending)

  React.useEffect(() => {
    clientProfileMounted()
    partnerMounted()
  }, [clientID])

  return {
    clientProfile,
    manualTransfer,
    manualTransferError,
    partner,
    partnerError,
    fullPartnerForClient,
    loadingAutoWDStatus,
  }
}
